import { Avatar, Button, Typography } from '@mui/material';
import { GetDocumentFile } from 'API/documents';
import { Dictionary } from 'Dictionary';
import { DICTIONARY } from 'Enum';
import { useLoader } from 'Hooks/useLoader';
import { Download2 } from 'Images';
import { downloadFile } from 'Utils';

interface IDownloadDocument {
  docId: number;
  docType: number;
  docName: string;
}

export const DownloadDocument = ({
  docId,
  docType,
  docName,
}: IDownloadDocument) => {
  const { isLoading, setIsLoading, loader } = useLoader(
    '25',
    {
      width: '100%',
      height: '44px',
      position: 'absolute',
      bottom: 0,
      right: 0,
    },
    25,
    false
  );

  const documentDownloadHandler = async () => {
    setIsLoading(true);
    const documentFile = await GetDocumentFile(docType, docId);
    if (documentFile?.contentBase64)
      downloadFile(documentFile.contentBase64, 'pdf', docName);
    setIsLoading(false);
  };

  return (
    <>
      {isLoading ? (
        loader
      ) : (
        <Button
          sx={{
            width: '100%',
            height: '44px',
            pr: '20px',
            position: 'absolute',
            bottom: 0,
            right: 0,
            bgcolor: '#E7EDFF',
            borderRadius: '0 0 16px 16px',
            display: 'flex',
            justifyContent: 'flex-end',
            gap: '6px',
          }}
          onClick={documentDownloadHandler}
        >
          <Avatar
            alt=''
            src={Download2}
            sx={{ width: '20px', height: '20px' }}
          />
          <Typography variant='body5'>
            {Dictionary[DICTIONARY.Documents].downloadDoc}
          </Typography>
        </Button>
      )}
    </>
  );
};
